import React from 'react'
import { Box } from 'swx-atomic-component-lib'
import profileStyles from './profileStyles'
import passwordCriteriaFunc from './PasswordStrength.utils'

function PasswordStrengthMeterCarbon (props) {
  const { password, score, zxcvbnResult, minScore } = props
  const { dataStrength, passResult, allSuggestions, suggestionResult } = passwordCriteriaFunc({ zxcvbnResult, password, score, minScore })

  const suggestionListStyle = { fontSize: '14px' }

  return (
    <Box>
      <Box customStyle={profileStyles.fullStrengthMeter}>
        <Box customStyle={profileStyles.strengthMeter}>
          <Box customStyle={profileStyles.strengthMeterFill} data-strength={dataStrength} />
        </Box>
        <Box customStyle='display: flex;'>
          <Box className='weak-label'>Weak</Box><Box className='strong-label'>Strong</Box>
        </Box>
      </Box>
      {
        dataStrength >= 0 && (
          <Box customStyle={profileStyles.fullPasswordStrengthMeterResult}>
            <Box customStyle='display: inline-block;'>
              <Box className='suggestion-label'>{passResult}</Box>
              {allSuggestions.length > 0 && (
                <div>
                  <Box className='suggestion-label'>{suggestionResult}</Box>
                  <ul style={suggestionListStyle}>{allSuggestions.map((li, i) => <li key={i}>{li}</li>)}</ul>
                </div>
              )}
            </Box>
          </Box>
        )
      }

    </Box>
  )
}

export default PasswordStrengthMeterCarbon
